import { Component, OnInit } from '@angular/core';
import { ProductCpuService } from '../../../services/product-cpu.service';
import { ProductService } from '../../../../products/services/product.service';


@Component({
  selector: 'app-list-product-cpus',
  templateUrl: './list-product-cpus.component.html',
  styleUrls: ['./list-product-cpus.component.css'],
  providers:[ProductCpuService, ProductService]
})
export class ListProductCpusComponent implements OnInit {

  productCpus:any = [];

  constructor(private productCpuService:ProductCpuService, private productService: ProductService) { }

  ngOnInit() {
    this.getProductCpus();
  }

  getProductCpus(){
    this.productCpuService.query({})
      .subscribe((productCpus) => {
        this.productCpus = productCpus;
        this.parseProducts();
      });
  }

  delete(productCpu){
    this.productService.query({cpu:productCpu.id})
    .subscribe((products) => {
      if (products.length > 0){
        alert("No se puede borrar debido ha que existen productos relacionados")
      }else{
        this.productCpuService.delete(productCpu.id)
        .subscribe((productCpus) => {
          this.getProductCpus()
        });
      }
    });
  }

  parseProducts(){
    this.productCpus.forEach(function (productCpu){
      productCpu.productTypes = "";
      if(productCpu.product_types.includes("1")){
        productCpu.productTypes += "Móviles y Tablets,";
      }
      if(productCpu.product_types.includes("2")){
        productCpu.productTypes += "Consolas,";
      }
      if(productCpu.product_types.includes("3")){
        productCpu.productTypes += "Artículos Varios,";
      }
      if(productCpu.product_types.includes("4")){
        productCpu.productTypes += "PC's-portátiles,";
      }
      productCpu.productTypes = productCpu.productTypes.substring(0,productCpu.productTypes.length - 1);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/configuration/components/product-cpus/list-product-cpus/list-product-cpus.component.ts